import { useNavigate } from 'react-router-dom';
import { useDirtyContext } from '../contexts/DirtyContext';
import { useConfirm } from '../contexts/ConfirmContext';
import { aiLeavePrompt, getAiJobs } from './useAiWork';

const useCustomNavigate = () => {
    const navigate = useNavigate();
    const { isDirty,setIsDirty } = useDirtyContext();
    const confirm = useConfirm();

    const customNavigate = async (to: string) => {
        const aiJob = getAiJobs()[0];
        if (aiJob || isDirty) {
            const confirmLeave = await confirm(aiJob ? aiLeavePrompt(aiJob.label, isDirty) : {
                danger: true,
                entity: "Unsaved Changes",
                titleVerb: "Discard",
                confirmLabel: "Leave",
                cancelLabel: "Stay",
                message: "You have unsaved changes. Are you sure you want to leave?",
            });
            if (!confirmLeave) {
                return; // Prevent navigation
            }
            else{
                setIsDirty(false)
            }
        }
        navigate(to); // Proceed with navigation
    };

    return customNavigate;
};

export default useCustomNavigate;
